module.exports = __webpack_public_path__ + "img/icon-consultar.ecf3b136.svg";